import { LandscapeResponseDto } from '../dto/response/landscape-response.dto';
import { LandscapeSaveRequestDto } from '../dto/request/landscape-save-request.dto';
import { LandscapeUpdateRequestDto } from '../dto/request/landscape-update-request.dto';
import { LandscapeSummaryResponseDto } from '../dto/response/landscape-summary-response.dto';
import { LandscapePagedListResponseDto } from '../dto/response/landscape-paged-list-response.dto';
import { BaseLandscapeService } from '../../base-landscape.service';
import userService from '../../../contextAPI/user/services/user.service';
import {
  getLanguageKey,
  LocalesLanguagesConstants,
} from '../../../../locales/locales';

class LandscapeService extends BaseLandscapeService {
  public async fetchLandscapes(): Promise<LandscapeResponseDto[]> {
    const contextIds = await userService.fetchLoggedInUserContextIds();
    const response = await this.get<LandscapeResponseDto[]>(`/compact`);
    const landscapes = response.data;

    if (contextIds.length === 0) {
      return landscapes;
    }

    return landscapes.filter((landscape) => contextIds.includes(landscape.id));
  }

  public async fetchOrganizationLandscapes(
    id: string
  ): Promise<LandscapeResponseDto[]> {
    const contextIds = await userService.fetchLoggedInUserContextIds();
    const response = await this.get<LandscapeResponseDto[]>(
      `/compact/organizatoncompacts/${id}`
    );
    const landscapes = response.data;

    if (contextIds.length === 0) {
      return landscapes;
    }

    return landscapes.filter((landscape) => contextIds.includes(landscape.id));
  }

  public async fetchLandscapeById(
    id: string,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<LandscapeResponseDto> {
    const response = await this.get<LandscapeResponseDto>(`/compact/${id}`, {
      headers: {
        'accept-language': getLanguageKey(language),
      },
    });
    return response.data;
  }

  public async fetchLandscapeSummaries(): Promise<
    LandscapeSummaryResponseDto[]
  > {
    const response =
      await this.get<LandscapeSummaryResponseDto[]>(`/compact/summary`);
    return response.data;
  }

  public async fetchLandscapesPaged(
    pageIndex: number,
    pageSize: number
  ): Promise<LandscapePagedListResponseDto> {
    const response = await this.get<LandscapePagedListResponseDto>(
      `/compact/paged`,
      {
        params: {
          PageIndex: pageIndex,
          PageSize: pageSize,
        },
      }
    );
    return response.data;
  }

  public async saveLandscape(
    saveRequest: LandscapeSaveRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<LandscapeResponseDto> {
    const response = await this.post<LandscapeResponseDto>(
      `/compact`,
      saveRequest,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async updateLandscape(
    updateRequest: LandscapeUpdateRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<LandscapeResponseDto> {
    const response = await this.put<LandscapeResponseDto>(
      `/compact`,
      updateRequest,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async deleteLandscape(existingId: string): Promise<void> {
    await this.delete<void>(`/compact/${existingId}`);
  }
}

const landscapeService = new LandscapeService();
export default landscapeService;
